import React, { useEffect, useState } from "react";
import icon from "../../../images/team-icon.png";
import BsySearchResult from "../../BsySearchResult";

export function ChangeAppPane({
  apps,
  selectAppid,
  onClose,
  favoritesItems = [],
}) {
  const [expGroup, SetExpGroup] = useState([]);
  const [items, setItems] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [animation, setAnimation] = useState("");
  const [isShowFavorites, setIsShowFavorites] = useState(true);
  const [isShowmyApp, setIsShowmyApp] = useState(true);
  useEffect(() => {
    let list = [];
    apps.map((app) => {
      app.apps.map((item) => {
        list.push({
          ...item,
          name: item.appname,
        });
        return null;
      });
      return null;
    });
    setItems(list);

    setFavorites(favoritesItems);
  }, [apps, favoritesItems]);

  const toTarget = (val) => {
    return () => {
      window.location.href = window.rootDirectroy + "/team/app/" + val._id;
    };
  };

  const FavoritesToTarget = (item) => {
    return () => {
      // console.log(item)
      if (item.type === "app") {
        window.location.href =
          window.rootDirectroy + "/team/app/" + item.value.appId;
      }
      if (item.type === "entry") {
        window.location.href =
          window.rootDirectroy +
          "/team/app/" +
          item.value.appId +
          "/" +
          (item.value.type || "form") +
          "/" +
          item.value.entryId;
      }
    };
  };

  useEffect(() => {
    setAnimation("show");
    return () => {
      setAnimation("");
    };
  }, []);

  return (
    <div className={`bsy-change-apps ${animation}`}>
      <div className="top-go-home">
        <div
          className="go-home"
          // data-for='goHomeTip'
          // data-tip={React.language('dashboard')}
          onClick={() => {
            window.location.href = window.rootDirectroy + "/";
          }}
        >
          <span
            style={{
              backgroundImage: `url(${icon})`,
              width: 26,
              height: 26,
              backgroundSize: "contain",
              marginRight: 10,
            }}
          ></span>

          <span
            style={{
              marginRight: 3,
            }}
          >
            {React.language("dashboard")}
          </span>
        </div>
        <i
          className="icon-close-large"
          onClick={() => {
            onClose?.();
          }}
        ></i>
      </div>
      <BsySearchResult
        dockPosition="left"
        items={items}
        width={"auto"}
        height={280}
        placeholder={React.language("input.app.name")}
        onCreatResult={(res) => {
          let list = [];
          for (let i = 0; i < res.length; i++) {
            if (res[i].type !== "group") {
              list.push(res[i]);
            }
          }
          return list.length > 0 ? (
            <ul
              className="frame-search-entry"
              style={{
                height: 320,
                width: 320,
                overflow: "auto",
              }}
            >
              {list.map((val) => {
                return (
                  val && (
                    <li key={val._id}>
                      {
                        <div
                          className="menu-item"
                          title={val.text}
                          onClick={toTarget(val)}
                        >
                          <div
                            className="icon-wrapper"
                            style={{
                              width: 24,
                              height: 24,
                            }}
                          >
                            <div
                              className={`icon-backgroup color-cover-${val.style.color}`}
                              style={{
                                height: "100%",
                                borderRadius: 4,
                              }}
                            >
                              <div
                                className={`imgbg-bsy-app imgbg-bsy-app-${val.style.icon}`}
                              ></div>
                            </div>
                          </div>
                          <span
                            dangerouslySetInnerHTML={{ __html: val.titleHtml }}
                          />
                        </div>
                      }
                    </li>
                  )
                );
              })}
            </ul>
          ) : (
            <div className="emptySearch">
              {React.language("field.location.empty")}
            </div>
          );
        }}
      />
      <div className="apps-list">
        {favorites.length > 0 && (
          <>
            <div
              className="my-app-title my-app-title-first"
              onClick={() => {
                setIsShowFavorites(!isShowFavorites);
              }}
            >
              <div className="my-app-title-text">
                {React.language("app.favorites")}
              </div>
              <i
                className={`${
                  isShowFavorites
                    ? "icon-cg icon-new-up"
                    : "icon-cg icon-new-dowm"
                }`}
                onClick={() => {
                  setIsShowFavorites(!isShowFavorites);
                }}
              ></i>
            </div>
            {isShowFavorites && (
              <div className="app-item-group">
                <div className="app-item-group-list">
                  {(favorites || []).map((item, index) => {
                    return (
                      <>
                        {item.isValid && (
                          <div
                            key={index}
                            className={`app-item-list-item `}
                            onClick={FavoritesToTarget(item)}
                          >
                            <div className="icon-wrapper">
                              {item.type === "app" && (
                                <div
                                  className={`icon-backgroup color-cover-${item.value.style.color}`}
                                >
                                  <div
                                    className={`imgbg-bsy-app imgbg-bsy-app-${item.value.style.icon}`}
                                  ></div>
                                </div>
                              )}

                              {item.type === "entry" && (
                                <i
                                  className={`node-icon icon-bsy-${
                                    item.value.type
                                  } ${
                                    item.value.icon > 24
                                      ? `icon-new-bsy-form-${item.value.icon}`
                                      : `icon-bsy-form-${item.value.icon}`
                                  }`}
                                ></i>
                              )}
                            </div>
                            <span>{item.value.appname || item.value.name}</span>
                          </div>
                        )}
                        {!item.isValid && (
                          <div key={index} className={`app-item-list-item `}>
                            <div className="icon-wrapper">
                              <i className="node-icon icon-bsy-help"></i>
                            </div>
                            <span>收藏已失效</span>
                          </div>
                        )}
                      </>
                    );
                  })}
                </div>
              </div>
            )}
          </>
        )}
        <div
          className="my-app-title"
          onClick={() => {
            setIsShowmyApp(!isShowmyApp);
          }}
        >
          <div className="my-app-title-text">{React.language("app.mine")}</div>
          <i
            className={`${
              isShowmyApp ? "icon-cg icon-new-up" : "icon-cg icon-new-dowm"
            }`}
            onClick={() => {
              setIsShowmyApp(!isShowmyApp);
            }}
          ></i>
        </div>
        {isShowmyApp &&
          apps.map((appitem, index) => {
            const { apps: list } = appitem;

            if(list.length === 0) {
              return '';
            }

            return (
              <div key={index} className="app-item-group">
                <div
                  className="app-item-group-title"
                  title={appitem.name}
                  onClick={() => {
                    SetExpGroup(
                      expGroup.includes(appitem._id)
                        ? expGroup.filter((id) => id !== appitem._id)
                        : [...expGroup, appitem._id]
                    );
                  }}
                >
                  <i
                    className={`${
                      expGroup.includes(appitem._id)
                        ? "icon-new-left-solid"
                        : "icon-new-dowm-solid"
                    }`}
                  ></i>
                  <span>{appitem.name}</span>
                </div>
                <div
                  className="app-item-group-list"
                  style={{
                    display: expGroup.includes(appitem._id) ? "none" : "",
                  }}
                >
                  {list.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className={`app-item-list-item ${
                          selectAppid === item._id ? "select" : ""
                        }`}
                        onClick={() => {
                          window.location.href =
                            window.rootDirectroy + "/team/app/" + item._id;
                          onClose?.();
                        }}
                      >
                        <div className="icon-wrapper">
                          <div
                            className={`icon-backgroup color-cover-${item.style.color}`}
                          >
                            <div
                              className={`imgbg-bsy-app imgbg-bsy-app-${item.style.icon}`}
                            ></div>
                          </div>
                        </div>
                        <span>{item.appname}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}
